<template>
    <div id="data-list-list-view" >
    <vs-alert color="danger" title="Course Class Not Found" :active.sync="not_found">
      <span>Course   with id: {{ $route.params.ID }} {{$t('NotFound')}}. </span>
      <span>
        <span> </span><router-link :to="{name:'Traineehome'}" class="text-inherit underline">{{$t('Back')}}</router-link>
      </span>
    </vs-alert>

   <vs-alert color="success" title="Registration Successfully" :active.sync="status">
      <span>{{$t('YouHaveRegisterSuccessfullyWithCode')}}: {{registerResponse.Code}}. </span>
      <span>
         <span> {{$t('FollowRegistrationByClick')}} </span><router-link :to="{name:'RegistrationStatus',params: { Code: registerResponse.Code}}" class="text-inherit underline">here</router-link>
      </span>
    </vs-alert>

    <div v-if="!not_found&&!status">
         <div class="vx-row">
             <div class="vx-col lg:w-1/2 w-full">
                <vx-card :title="$t('TraineeInfo')"  class="mb-base">
                     <vs-table>
                        <tr>
                            <td class="font-semibold">{{$t('Name')}}</td>
                            <td> {{model.Name}} </td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t('Email')}}</td>
                            <td> {{model.Email}} </td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t('WorkEmail')}}</td>
                            <td> {{model.WorkEmail}} </td>
                        </tr>
                    </vs-table>
                </vx-card>
                 <vx-card title="Invoice Info"  class="mb-base">

                     <div class=" vx-col flex-1" >
                         <p>{{$t('PaymentType')}}</p>
                                         <v-select
                                          label="Name"
                                          class=" w-full"
                                            autocomplete
                                          v-model="model.PaymentTypeID"
                                          :options="PaymentTypes"
                                          :reduce="ID => ID.ID"
                                        />

                        <span class="text-danger text-sm"  v-show="errors.has('PaymentType')">{{ errors.first('PaymentType') }}</span>
                      </div>

                </vx-card>
             </div>
            <div class="vx-col lg:w-1/2 w-full" >
                <vx-card title="Course Class Info"  class="mb-base">
                     <vs-table>
                        <tr>
                            <td class="font-semibold">{{$t('Course')}}</td>
                            <td> {{model.AnnualPlan.Course.Name}} </td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t('CalssNo')}}</td>
                            <td> {{model.AnnualPlan.ClassNo}} </td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t('Period')}}</td>
                            <td>{{model.AnnualPlan.StartDate.split('T')[0]}} - {{model.AnnualPlan.EndDate.split('T')[0]}}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t('Provider')}}</td>
                            <td> <span v-if="model.AnnualPlan.ProviderID!=null">{{model.AnnualPlan.Provider.Name}}</span><span v-if="model.AnnualPlan.ProviderID==null">UATS</span> </td>
                        </tr>
                         <tr>
                            <td class="font-semibold">{{$t('RegistrationDue')}}</td>
                            <td> {{model.AnnualPlan.RegistrationDateDue.split('T')[0]}}</td>
                        </tr>
                     </vs-table>
                       <div class="text-warning mt-5" >{{$t('CourseQualifies')}}  </div>  
                      <vs-table>
                        <tr>
                            <td class="font-semibold">{{$t('Diploma')}}</td>
                            <td>
                                <div class=" vx-col flex-1" >
                                     <v-select
                                          label="Name"
                                          class=" w-full"
                                            autocomplete
                                          v-model="model.CourseTrackID"
                                          :options="tracks"
                                          :reduce="ID => ID.ID"
                                        />
                                </div>
                            </td>
                        </tr>
                    </vs-table>
                </vx-card>
            </div>
         </div>
          <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button class="mr-6" @click="Confirm" >{{$t('Confirm')}}</vs-button>
                    <vs-button type="border" color="danger" :to="{ path: '/Traineehome' }">{{$t('Close')}}</vs-button>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>

import moduleTrack from "@/store/track/moduleTrack.js";
import moduleAnnualPlan from "@/store/annualPlan/moduleAnnualPlan.js";
import moduleCourseRegistration from "@/store/courseRegistration/moduleCourseRegistration.js";
import modulePaymentType from "@/store/settings/paymentType/modulePaymentType.js";
import vSelect from 'vue-select';
export default {

    data()
    {
        return{
            status:false,
            registerResponse:{},
            invoice:2,
            model:{},
           not_found:false,
        }
    },
    components:{
vSelect
    },
    methods:{
        notifyAlert(color,title,text) {
            this.$vs.notify({ time:8000,
                color: color,
                title: title,
                text: text
            });
        },
        Confirm()
        {
            var registerModule={};
            registerModule.AnnualPlanID=this.model.AnnualPlan.ID;
            registerModule.TraineeID=this.model.TraineeID;
            registerModule.IsSendMail=true;
            registerModule.StatusID=1;
            registerModule.StatusComment="New Registration";
            registerModule.IsAccommodation=this.model.IsAccommodation;
            registerModule.PaymentTypeID=this.model.PaymentTypeID;
            registerModule.CourseTrackID = this.model.CourseTrackID;
           //  var vm=this;
           this.$store.dispatch("courseRegistrationList/addItem", registerModule).then(res=>{
               this.status = true;
               this.registerResponse.Code = res.data.Code;
               return
           }).catch(err => {
               this.notifyAlert("danger",this.$t("Error"),err.response.data);
            })
        }
    },
    computed:{
         tracks() {
            return this.$store.state.trackList.tracks;
            },
        PaymentTypes() {
            return this.$store.state.PaymentTypeList.PaymentTypes;
            },
    },
    created(){

        if (!moduleAnnualPlan.isRegistered) {
            this.$store.registerModule("annualPlanList", moduleAnnualPlan);
            moduleAnnualPlan.isRegistered = true;
           }
            if (!moduleCourseRegistration.isRegistered) {
                this.$store.registerModule("courseRegistrationList", moduleCourseRegistration);
                moduleCourseRegistration.isRegistered = true;
                }

            if (!modulePaymentType.isRegistered) {
            this.$store.registerModule("PaymentTypeList", modulePaymentType);
            modulePaymentType.isRegistered = true;
            }
            this.$store.dispatch("PaymentTypeList/fetchDataListItems");

            if (!moduleTrack.isRegistered) {
                this.$store.registerModule("trackList", moduleTrack);
                moduleTrack.isRegistered = true;
                }

           const ID = this.$route.params.ID

            if(ID!=undefined)
            {

            this.$store.dispatch("annualPlanList/GetAnnualPlanByIDWithTrainee", ID)
            .then(res => {
                debugger
                this.model = res.data;
                this.model.PaymentTypeID = 1;
                  var search={};
                search.CourseID= this.model.AnnualPlan.Course.ID;
                this.$store.dispatch("trackList/fetchDataListItemsByFilter",search);
            })
            .catch(err => {
                if(err.response.status === 404) {
                this.not_found = true;
                return
                }
                console.error(err)
               })
            }
    },

}
</script>


<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

</style>


<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.vs-table--not-data
{
  display: none;
}
</style>
